import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { ValueFactory } from '~/editors/values'

import style from './style.css'

export default class KeyframeEditor extends React.Component {
  
  static propTypes = {
    time : PropTypes.number,
    timeline : PropTypes.object,
    attribute : PropTypes.object,
    keyframe : PropTypes.object,
    onSet : PropTypes.func.isRequired,
    onCancel : PropTypes.func.isRequired,
    onRemove : PropTypes.func.isRequired
  }

  onValueChange = ( evt ) => {
    const { keyframe, timeline, time } = this.props
    this.props.onSet( { value : evt.value, keyframe, timeline, time } )
  }

  onCancel = () => {
    this.props.onCancel( this.props )
  }

  onRemove = () => {
    const { keyframe, timeline } = this.props
    this.props.onRemove( { timeline, keyframe } )
  }

  render() {
    const { attribute, keyframe } = this.props
    const prps = { focus : true, onChange : this.onValueChange, changeOnBlur : true }
    if ( keyframe ) {
      prps.value = keyframe.value
    }
    const valueEditor = ValueFactory.createEditor( attribute, prps );
    return ( 
      <div className={style.keyframeEditor}>
        {valueEditor}
        <div className={style.keyframeEditorButtons}>
          <Button bsStyle="link" onClick={this.onCancel}>Cancel</Button>
          { this.props.keyframe ? <Button bsStyle="link" onClick={this.onRemove}>Delete</Button> : null }
        </div>
      </div>
    )
  }
}
